import { Box } from '@material-ui/core';
import { userroles } from '../../../constants';
import useCompany from '../../../../hooks/useCompany';
import useTasks from '../../../../hooks/useTasks';
import Tasks from '../../../../pages/adds/Tasks';
import { getStoreItem, setStoreItem } from '../../../../store';
import {
  ContractContext,
  contractReducer,
  initContractContext,
} from '../../../../contexts/managment';
import { useEffect, useReducer } from 'react';

function ContractsList({ isRTL, theme, words, height }) {
  const { tasks } = useTasks();
  const { company } = useCompany();

  const contractStoreState = getStoreItem('contractStore', initContractContext);
  const [contractStore, contractDispatch] = useReducer(
    contractReducer,
    contractStoreState ? contractStoreState : initContractContext
  );
  useEffect(() => {
    setStoreItem('contractStore', contractStore);
  }, [contractStore]);

  return (
    <Box>
      {userroles?.operations?.admin && tasks && (
        <ContractContext.Provider
          value={{ state: contractStore, dispatch: contractDispatch }}
        >
          <Tasks
            isRTL={isRTL}
            words={words}
            theme={theme}
            company={company}
            height={height}
          ></Tasks>
        </ContractContext.Provider>
      )}
    </Box>
  );
}

export default ContractsList;
